<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工作任务</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-items: center">
      <el-button size="mini"  @click="showTaskDialog">发起新任务</el-button>
      <el-badge :value="pendNum" style="margin-left: 10px">
        <el-button size="mini" @click="pending">我待办理的</el-button>
      </el-badge>

      <el-badge :value="iCreateNum" style="margin-left: 10px">
        <el-button size="mini"  @click="iCreate">我发起的</el-button>
      </el-badge>
      <el-badge :value="iExeNum" style="margin-left: 10px">
        <el-button size="mini"  @click="iExeMethod">我执行的</el-button>
      </el-badge>

      <el-badge :value="iHelpNum" style="margin-left: 10px">
        <el-button size="mini"  @click="iHelp">我协助的</el-button>
      </el-badge>

      <el-badge :value="sendMeNum" style="margin-left: 10px">
        <el-button size="mini"  @click="sendMe">抄送我的</el-button>
      </el-badge>
<!--      <el-button size="mini" style="margin-left: 20px"  @click="underway">进行中</el-button>-->
<!--      <el-button size="mini" style="margin-left: 20px"  @click="finish">已完结</el-button>-->

      <el-date-picker
        v-model="taskRequest.selectDay"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectReportDataDay"
        value-format="yyyy-MM-dd"
        style="margin-left: 20px"
      >
      </el-date-picker>
      <el-select v-model="selectTaskTypeId" clearable value filterable placeholder="请选择"
                 style="width: 150px" size="mini" @change="getTaskType">
        <el-option
          v-for="taskType in taskTypeList"
          :key="taskType.id"
          :label="taskType.label"
          :value="taskType.id">
        </el-option>
      </el-select>
      <el-button size="mini" style="margin-left: 5px;" @click="loadTask">查询</el-button>
    </div>
    <el-table height="550px" :data="taskList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333', padding: '0'}"
              :row-style="{height: '0'}" :cell-style="{padding: '0'}"
    >
      <el-table-column
        align="center"
        label="操作"
        width="100"
      >
        <template slot-scope="scope">
          <el-link type="primary"  icon="iconfont icon-xiangqing"
                   @click="showDetailDialog(scope.row)"></el-link>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="创建时间"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="taskTitle"
        label="任务名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="shopName"
        label="所属部门"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="createName"
        label="发起人"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="receiveName"
        label="执行人"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="state"
        :formatter="stateFormatter"
        label="任务状态"
      >
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="ticketHandleSizeChange"
        @current-change="ticketHandleCurrentChange"
        :current-page="ticketCurrentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="ticketPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="ticketPageTotal">
      </el-pagination>
    </div>
    <!-- 发起任务 -->
    <el-dialog
      title="创建任务"
      :visible.sync="addTaskDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeTaskDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <span>任务标题：</span>
        <el-input v-model="workTask.taskTitle" placeholder="请输入内容" size="mini"
                  style="width: 300px;"></el-input>
      </el-card>
      <el-card style="margin-top: 10px">
        <div style="display: flex">
          <span>任务内容：</span>
          <el-input v-model="workTask.taskContent" placeholder="请输入内容" type="textarea"
                    style="width: 90%;"></el-input>
        </div>
      </el-card>
      <el-card style="margin-top: 10px">
        <el-form id="addForm">
          <el-form-item>
            <el-upload
              :action="uploadUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :before-upload="beforeAvatarUpload"
              :on-success="detailHandleAvatarSuccess"
              ref="uploadImg"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card>
        <span>任务执行人：</span>
        <el-select v-model="receiveUser" size="mini" filterable placeholder="请选择" @change="getReceive">
          <el-option
            v-for="item in userList"
            :key="item.id"
            :label="item.userName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-card>
      <el-card>
        <div style="display:flex;justify-items: center;justify-content: space-around">
          <div style="width: 50%">
            <span>任务协助人：</span>
            <el-select v-model="helpUsers" style="width: 70%" filterable size="mini" multiple placeholder="请选择">
              <el-option
                v-for="(item,index) in userList"
                :key="index"
                :label="item.userName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="width: 50%">
            <span>任务抄送人：</span>
            <el-select v-model="sendUsers" style="width: 70%" filterable size="mini" multiple placeholder="请选择">
              <el-option
                v-for="(item,index) in userList"
                :key="index"
                :label="item.userName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeTaskDialog">取 消</el-button>
        <el-button size="mini" @click="createWorkTask">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 发起任务 -->
    <el-dialog
      title="任务详情"
      :visible.sync="taskDetailDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeTaskDetailDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <span>任务标题：</span>
        <el-input v-model="taskDetail.taskTitle" readonly placeholder="请输入内容" size="mini"
                  style="width: 300px;"></el-input>
      </el-card>
      <el-card>
        <div style="width: 100%;display: flex;justify-content: flex-start">
          <span>任务进度：</span>
          <div style="width: 90%;">
            <el-progress :percentage="percentage" :color="customColorMethod"></el-progress>
            <el-button :disabled="isExecute || taskDetail.state ==3" icon="el-icon-minus" @click="decrease" size="mini"></el-button>
            <el-button :disabled="isExecute || taskDetail.state ==3" icon="el-icon-plus" @click="increase" size="mini"></el-button>
          </div>
        </div>
      </el-card>
      <el-card style="margin-top: 10px">
        <div style="display: flex">
          <span>任务内容：</span>
          <el-input v-model="taskDetail.taskContent" readonly placeholder="请输入内容" type="textarea"
                    style="width: 90%;"></el-input>
        </div>
      </el-card>
      <el-card>
        <div style="width: 100%;display: flex;justify-content: space-between">
          <div style="width: 50%">
            <span>任务执行人：</span>
            <span>{{taskDetail.receiveName}}</span>
          </div>
        </div>
      </el-card>
<!--      <el-card>-->
      <div style="display: flex;width: 100%;justify-content: flex-start;flex-wrap: wrap">
        <div v-for="(item, index) in detailFileList" style="width: 150px" >
          <div style="display: flex;flex-direction: column;margin-right: 5px;">
            <span style="width: 100%">{{item.userName}}上传的图片</span>
            <el-image
              :src="item.url"
              :preview-src-list="detailSrcList">
            </el-image>
          </div>
          <br :key="index" v-if="index % 3 == 0">
        </div>
      </div>
<!--      </el-card>-->
      <el-card>
        <div style="display:flex;justify-items: center;justify-content: space-around">
          <div style="width: 50%">
            <span>任务协助人：</span>
            <el-select :disabled="isReSelect" v-model="showHelpActors" style="width: 70%" size="mini" multiple placeholder="请选择">
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.userName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="width: 50%">
            <span>任务抄送人：</span>
            <el-select :disabled="isReSelect" v-model="showSendActors" style="width: 70%" size="mini" multiple placeholder="请选择">
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.userName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-card>
      <el-card>
        <div style="display:flex;justify-items: center;justify-content: space-around">
          <div style="width: 50%">
            <span>任务协助人：</span>
            <el-select :disabled="isJxxz" v-model="showExistHelpActors" style="width: 70%" size="mini" multiple placeholder="请选择">
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.userName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="width: 50%">
            <el-button :disabled="isJxxz" size="mini" @click="jxHelpMethod">继续协助</el-button>
          </div>
        </div>
      </el-card>
      <el-card>
        <span>任务详情：</span>
        <el-timeline :reverse="true">
          <el-timeline-item
            v-for="(step, index) in stepList"
            :key="index"
            :timestamp="step.createTime">
            <span style="font-size: 12px;color: #8c939d">{{step.createName +"，"+ step.stepContent}}</span>
          </el-timeline-item>
        </el-timeline>
      </el-card>
      <el-card>
        <div style="display: flex">
          <span>上传附件：</span>
          <el-form id="hfForm">
            <el-form-item>
              <el-upload
                :action="uploadUrl"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :before-upload="beforeAvatarUpload"
                :on-success="detailHandleAvatarSuccess"
                ref="uploadImg"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
      <el-card>
        <div style="display: flex">
          <span>回复内容：</span>
          <el-input v-model="taskDetail.replyContent" placeholder="请输入内容" type="textarea"
                    :readonly="isEdit === true || taskDetail.state === 3"
                  style="width: 90%;"></el-input>
        </div>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeTaskDetailDialog">取 消</el-button>
        <el-button size="mini" @click="start" v-if="isExecute === false && taskDetail.state === 1">开 始</el-button>
        <el-button size="mini" @click="reply" v-if="isEdit === false && taskDetail.state !== 3">回 复</el-button>
        <el-button size="mini" @click="isFinish" v-if="isExecute === false && taskDetail.state !== 3">完 结</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data(){
    return{
      orgId:'',
      userId:'',
      userName:'',
      authorities:'',
      taskRequest:{
        selectDay:'',
        startDate:'',
        endDate:'',
        creator:0,
        pageNum:'',
        pageSize:'',
        state:'',
        receiveId:0,
        userId:'',
        helpActor:0,
        userType:''
      },
      selectTaskTypeId:'',
      taskTypeList:[
        {id:1, label:'我发起的'},
        {id:2, label:'我执行的'},
        {id:3, label:'我协助的'},
        {id:4, label:'抄送我的'},
      ],
      reportTabName:'',
      taskList:[],
      userList:[],
      addTaskDialogVisible:false,
      workTask:{
        taskTitle:'',
        taskContent:'',
        creator:'',
        receiveId:'',
        imageInfos:'',
        steps:[],
        helpActors:[],
        sendActors:[],
        shopId:'',
        jxHelpActors:[]
      },
      receiveUser:'',
      helpUsers:[],
      sendUsers:[],
      fileList:[],
      file:'',
      details:[],
      detailSrcList:[],
      detailFileList:[],
      currentPage: 1,
      pageSize:20,
      pageTotal:0,
      stateText:[
        {state:1, name:'发起'},
        {state:2, name:'进行中'},
        {state:3, name:'已完结'},
      ],
      stateArr:[
        {state:1, name:'发起'},
        {state:2, name:'进行中'},
        {state:3, name:'已完结'},
      ],
      taskDetailDialogVisible:false,
      taskDetail:{
        replyContent:'',
        taskTitle:'',
        workTaskImg:'',
        state:0,
        helpActors:[],
        sendActors:[],
        shopId:'',
        stepCreator:'',
        plan:'',
        imageInfos:'',
        creator:'',
        userId:'',
        userName:''
      },
      showHelpActors: [],
      showSendActors: [],
      //任务已经存在的协助人
      showExistHelpActors: [],
      stepList:[],
      percentage: 0,
      customColor: '#409eff',
      customColors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f7ad3', percentage: 100}
      ],
      plan:0,
      pendNum:0,
      sendMeNum:0,
      iCreateNum:0,
      iExeNum:0,
      iHelpNum:0,

      ticketCurrentPage: 1,
      ticketPageSize:20,
      ticketPageTotal:0,
      //1.待办理  2.已办理  3.确认办理 4.继续办理 5.待阅读  6.已阅读
      dataType:0,
      // uploadUrl:'https://www.529foot.com/api/v1/upload/work/file',
      uploadUrl:'http://39.103.148.110:8082/api/v1/upload/work/file',
      // uploadUrl:'http://localhost:8088/api/v1/upload/work/file',
      direction:'ltr',
      dialogImageUrl: '',
      dialogVisible: false,
      isEdit:true,
      isExecute:true,
      isReSelect:true,
      isJxxz:true,
      operateType:'',
      jxWorkTask:{
        id:'',
        jxHelpActors:[]
      },
    }
  },
  methods:{
    selectReportDataDay(data){
      if (data == null){
        this.taskRequest.selectDay = '';
        this.taskRequest.startDate = '';
        this.taskRequest.endDate = '';
      } else {
        this.taskRequest.selectDay = data;
        this.taskRequest.startDate = data[0];
        this.taskRequest.endDate = data[1];
      }
    },
    getReceive(data){
      this.workTask.receiveId = data;
    },
    getTaskType(data){
      this.clear();
      this.taskRequest.userId = this.userId;
      this.taskRequest.userType = data;
    },
    async isImage(file) {
      return await this.isGif(file) || await this.isPng(file) || await this.isJpg(file)
    },
    async isPng(file) { //判断是否是png
      const ret = await this.blobToString(file.slice(0, 8))
      return (ret === '89 50 4E 47 D A 1A A')
    },
    async isJpg(file) { //判断是否是jpg
      const len = file.size
      const start = await this.blobToString(file.slice(0, 2))
      const tail = await this.blobToString(file.slice(-2, len))
      return (start === 'FF D8') && (tail == 'FF D9')
    },
    async isGif(file) { //判断是否是gif
      // GIF89a 和 GIF87a
      // 前面6个16进制， '47 49 46 38 39 61' or '47 49 46 38 37 61'
      const ret = await this.blobToString(file.slice(0, 6))
      return (ret === '47 49 46 38 39 61') || (ret === '47 49 46 38 37 61')
    },
    blobToString(blob) {
      return new Promise(reslove => {
        const reader = new FileReader()
        reader.onload = function() {
          const ret = reader.result.split('')
            .map(v => v.charCodeAt())
            .map(v => v.toString(16).toUpperCase())
            .join(' ')
          reslove(ret)
        }
        reader.readAsBinaryString(blob) // 开启读取
      })
    },
    async loadTask(){
      this.taskRequest.pageNum = this.currentPage;
      this.taskRequest.pageSize = this.pageSize;
      await this.loadTaskCount();
      await this.loadTaskList();
    },
    async loadTaskCount(){
      const {data:res} = await this.$http.post(`/load/work/task/count`, this.taskRequest)
      this.ticketPageTotal = res.totalPage;
    },
    async loadTaskList(){
      const {data:res} = await this.$http.post(`/load/work/task/list`, this.taskRequest)
      this.taskList = res.data;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    async beforeAvatarUpload(file){
      this.file = file;
      if (!await this.isImage(file)) { //判断是否是图片
        this.$message.warning('文件格式不正确！')
        return
      }

      const imgSize = file.size / 1024 /1024 > 10
      if (imgSize){
        return this.$message.warning("上传图片不能大于10MB！")
      }
    },
    detailHandleAvatarSuccess(res, fileList){
      this.details.push(res.data);
      this.fileList = fileList;
    },
    loadReadTask(){
      this.taskRequest.pageNum = this.currentPage;
      this.taskRequest.pageSize = this.pageSize;
      this.loadReadTaskCount();
      this.loadReadTaskList();
    },
    loadIexeTask(){
      this.taskRequest.pageNum = this.currentPage;
      this.taskRequest.pageSize = this.pageSize;
      this.loadIexeTaskCount();
      this.loadIexeTaskList();
    },
    loadIHelpTask(){
      this.taskRequest.pageNum = this.currentPage;
      this.taskRequest.pageSize = this.pageSize;
      this.loadIHelpTaskCount();
      this.loadIHelpTaskList();
    },
    loadSendMeTask(){
      this.taskRequest.pageNum = this.currentPage;
      this.taskRequest.pageSize = this.pageSize;
      this.loadSendMeTaskCount();
      this.loadSendMeTaskList();
    },
    async loadSendMeTaskCount(){
      const {data:res} = await this.$http.post(`/load/send/me/work/task/count`, this.taskRequest)
      this.ticketPageTotal = res.totalPage;
    },
    async loadSendMeTaskList(){
      const {data:res} = await this.$http.post(`/load/send/me/work/task/list`, this.taskRequest)
      this.taskList = res.data;
    },
    async loadIHelpTaskCount(){
      const {data:res} = await this.$http.post(`/load/i/help/work/task/count`, this.taskRequest)
      this.ticketPageTotal = res.totalPage;
    },
    async loadIHelpTaskList(){
      const {data:res} = await this.$http.post(`/load/i/help/work/task/list`, this.taskRequest)
      this.taskList = res.data;
    },
    async loadIexeTaskCount(){
      const {data:res} = await this.$http.post(`/load/i/exe/work/task/count`, this.taskRequest)
      this.ticketPageTotal = res.totalPage;
    },
    async loadIexeTaskList(){
      const {data:res} = await this.$http.post(`/load/i/exe/work/task/list`, this.taskRequest)
      this.taskList = res.data;
    },
    async loadICreateTaskCount(){
      const {data:res} = await this.$http.post(`/load/i/create/work/task/count`, this.taskRequest)
      this.ticketPageTotal = res.totalPage;
    },
    async loadICreateTaskList(){
      const {data:res} = await this.$http.post(`/load/i/create/work/task/list`, this.taskRequest)
      this.taskList = res.data;
    },
    async loadTodoTaskCount(){
      const {data:res} = await this.$http.post(`/load/todo/work/task/count`, this.taskRequest)
      this.ticketPageTotal = res.totalPage;
    },
    async loadTodoTaskList(){
      const {data:res} = await this.$http.post(`/load/todo/work/task/list`, this.taskRequest)
      this.taskList = res.data;
    },
    async loadReadTaskCount(){
      const {data:res} = await this.$http.post(`/load/read/work/task/count`, this.taskRequest)
      this.ticketPageTotal = res.totalPage;
    },
    async loadReadTaskList(){
      const {data:res} = await this.$http.post(`/load/read/work/task/list`, this.taskRequest)
      this.taskList = res.data;
    },
    showTaskDialog(){
      this.loadAllUser();
      this.addTaskDialogVisible = true;
    },
    closeTaskDialog(){
      this.addTaskDialogVisible = false;
    },
    async createWorkTask(){
      this.workTask.helpActors = this.helpUsers;
      this.workTask.sendActors = this.sendUsers;
      this.workTask.creator = this.userId;
      this.workTask.imageInfos = this.details;
      this.workTask.shopId = this.orgId;
      this.workTask.userId = this.userId;
      this.workTask.userName = this.userName;
      const {data:res} = await this.$http.post(`/new/work/task`, this.workTask)
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.closeTaskDialog();
    },
    async loadAllUser(){
      const {data:res} = await this.$http.get(`/report/users`)
      this.userList = res.data;
    },
    async loadDeptUser(){
      const {data:res} = await this.$http.get(`/org/users/${this.orgId}`);
      this.userList = res.data;
    },
    handleRemove(file, fileList) {
      let id1 = this.details.findIndex(item => {
        if (item.name === file.name) {
          return true
        }
      })
      this.details.splice(id1, 1)
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadTaskList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadTaskList();
    },
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    showDetailDialog(row){
      this.taskDetail.replyContent = '';
      this.jxWorkTask = row;
      if (this.authorities.includes('work.task.all.user')){
        this.loadAllUser();
      }
      if (this.authorities.includes('work.task.dept.user')){
        this.loadDeptUser();
      }
      this.loadWorkTaskDetail(row);
      this.execTask(row);
      this.fileList = '';

      this.taskDetailDialogVisible = true;
    },
    closeTaskDetailDialog(){
      if (this.operateType == 'iCreate'){
        this.loadICreateTaskNum();
        this.loadICreateTaskCount();
        this.loadICreateTaskList();
      }
      if (this.operateType == 'pending'){
        this.loadWaitTaskNum();
        this.loadTodoTaskCount();
        this.loadTodoTaskList();
      }
      if (this.operateType == 'iExe'){
        this.loadIExeTaskNum();
        this.loadIexeTaskCount();
        this.loadIexeTaskList();
      }
      if (this.operateType == 'iHelp'){
        this.loadIHelpTaskNum();
        this.loadIHelpTaskCount();
        this.loadIHelpTaskList();
      }
      if (this.operateType == 'sendMe'){
        this.loadSendMeTaskNum();
        this.loadSendMeTaskCount();
        this.loadSendMeTaskList();
      }
      this.taskDetailDialogVisible = false;
    },
    async start(){
      const {data:res} = await this.$http.post(`/start/work/task/${this.userId}`, this.taskDetail);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      // await this.loadWaitTaskNum();
      await this.closeTaskDetailDialog();
    },
    async execTask(row){
      await this.$http.post(`/exec/read/work/task/${this.userId}`, row);
    },
    async reply(){
      if(this.taskDetail.state == 1){
        return this.$message.warning("该任务还未开始，请联系任务执行人开始任务！");
      }

      if(this.taskDetail.replyContent == '' || this.taskDetail.replyContent == null){
        return this.$message.warning("请填写回复内容");
      }
      if (this.percentage == 100){
        this.$confirm('进度达到100%，任务将会自动变更为已完结，是否继续？', '进度提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.execReply();
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
        }).catch(() => {
          this.percentage = this.plan;
          this.$message({
            type: 'info',
            message: '已取消'
          });
        })
      } else {
        this.taskDetail.helpActors = this.showHelpActors;
        this.taskDetail.sendActors = this.showSendActors;
        this.taskDetail.stepCreator = this.userId;
        this.taskDetail.shopId = this.orgId;
        this.taskDetail.plan = this.percentage;
        this.taskDetail.imageInfos = this.details;
        this.taskDetail.userId = this.userId;
        this.taskDetail.userName = this.userName;
        const {data:res} = await this.$http.post(`/reply/work/task`, this.taskDetail)
        if (res.code === 200){
          this.$message.success("操作成功！")
          this.$router.go(0);
        }
      }
      await this.closeTaskDetailDialog();
    },
    async execReply(){
      this.taskDetail.helpActors = this.showHelpActors;
      this.taskDetail.sendActors = this.showSendActors;
      this.taskDetail.stepCreator = this.userId;
      this.taskDetail.shopId = this.orgId;
      this.taskDetail.plan = this.percentage;
      this.taskDetail.imageInfos = this.details;
      this.taskDetail.userId = this.userId;
      this.taskDetail.userName = this.userName;
      await this.$http.post(`/reply/work/task`, this.taskDetail)
      this.$router.go(0);
      // await this.loadWaitTaskNum();
      // await this.loadNotReadTaskNum();
      // await this.loadTask();
      // await this.loadReadTask();
    },

    isFinish(){
        if (this.percentage < 100){
          this.$confirm('任务进度还未达到100%, 是否完结?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.execFinish();
            this.$message({
              type: 'success',
              message: '成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          this.execFinish();
        }
    },
    async execFinish(){
      this.taskDetail.plan = 100;
      this.taskDetail.imageInfos = this.details;
      // this.taskDetail.creator = this.userId;
      // this.taskDetail.createName = this.userName;
      this.taskDetail.stepCreator = this.userId;
      this.taskDetail.shopId = this.orgId;
      this.taskDetail.userId = this.userId;
      this.taskDetail.userName = this.userName;
      await this.$http.post(`/finish/work/task`, this.taskDetail)
      this.$router.go(0);
      // await this.loadWaitTaskNum();
      // await this.loadNotReadTaskNum();
      // await this.loadTask();
      // await this.loadReadTask();
    },
    async loadWorkTaskDetail(data){
      this.detailSrcList = [];
      this.isEdit = true;
      this.isExecute = true;
      this.isReSelect = true;
      this.isJxxz = true;
      const {data:res} = await this.$http.get(`/load/work/task/detail/${data.id}`);
      this.taskDetail = res.data;
      this.showHelpActors = res.data.helpActors;
      this.showExistHelpActors = res.data.existHelpActors;
      if(this.userId == res.data.creator){
        this.isEdit = false;
        this.isReSelect = false;
      }
      if(this.userId == res.data.receiveId){
        this.isExecute = false
        this.isEdit = false;
        this.isJxxz = false;
      }
      if(this.showHelpActors.includes(this.userId - 0)){
        this.isEdit = false
      }

      this.showSendActors = res.data.sendActors;
      let imgs = res.data.workTaskImgs;
      this.detailFileList = res.data.workTaskImgs;
      imgs.map((item)=>{
        this.detailSrcList.push(item.url)
      })
      this.percentage = res.data.plan;
      this.plan = res.data.plan;
      this.stepList = res.data.steps;
    },
    customColorMethod(percentage) {
      if (percentage < 30) {
        return '#909399';
      } else if (percentage < 70) {
        return '#e6a23c';
      } else {
        return '#67c23a';
      }
    },
    increase() {
      this.percentage += 10;
      if (this.percentage > 100) {
        this.percentage = 100;
      }
    },
    decrease() {
      this.percentage -= 10;
      if (this.percentage < 0) {
        this.percentage = 0;
      }
    },
    clear(){
      this.taskRequest.receiveId = 0;
      this.taskRequest.userId = 0;
      this.taskRequest.creator = 0;
      this.taskRequest.state = 0;
    },
    pending(){
      // this.dataType = 1;
      // this.clear();
      this.operateType = 'pending';
      this.taskRequest.receiveId = this.userId;
      this.taskRequest.state = 1;
      this.taskRequest.pageNum = 1;
      this.taskRequest.pageSize = 20;
      this.loadTodoTaskCount();
      this.loadTodoTaskList();
    },
    // reading(){
    //   // this.dataType = 2;
    //   // this.clear();
    //   this.taskRequest.userId = this.userId;
    //   this.loadReadTask();
    //   // this.clear();
    // },
    iExeMethod(){
      // this.dataType = 2;
      // this.clear();
      this.operateType = 'iExe';
      debugger
      this.taskRequest.userId = this.userId;
      this.loadIexeTask();
      // this.clear();
    },
    iHelp(){
      this.operateType = 'iHelp';
      this.taskRequest.userId = this.userId;
      this.loadIHelpTask();
    },
    sendMe(){
      this.operateType = 'sendMe';
      this.taskRequest.userId = this.userId;
      this.loadSendMeTask();
    },
    //我发起的
    iCreate(){
      this.operateType = 'iCreate';
      this.taskRequest.pageNum = 1;
      this.taskRequest.pageSize = 20;
      this.loadICreateTaskCount();
      this.loadICreateTaskList();
    },
    finish(){
      this.dataType = 3;
      this.clear();
      this.taskRequest.userId = this.userId;
      this.taskRequest.state = 3;
      this.loadTask();
    },
    underway(){
      this.dataType = 4;
      this.clear();
      this.taskRequest.userId = this.userId;
      this.taskRequest.state = 2;
      this.loadTask();
    },
    async loadWaitTaskNum() {
      this.taskRequest.receiveId = this.userId;
      const {data: res} = await this.$http.post(`/load/todo/work/task/count`, this.taskRequest)
      this.pendNum = res.totalPage;
      // this.taskRequest.receiveId = 0;
      // this.taskRequest.creator = 0;
    },
    async loadICreateTaskNum() {
      this.taskRequest.userId = this.userId;
      const {data: res} = await this.$http.post(`/load/i/create/work/no/read/task/num`, this.taskRequest)
      this.iCreateNum = res.totalPage;

      this.taskRequest.receiveId = 0;
      this.taskRequest.creator = 0;
    },
    async loadIExeTaskNum() {
      this.taskRequest.userId = this.userId;
      const {data: res} = await this.$http.post(`/load/i/exe/work/no/read/task/num`, this.taskRequest)
      this.iExe = res.totalPage;

      this.taskRequest.receiveId = 0;
      this.taskRequest.creator = 0;
    },
    async loadIHelpTaskNum() {
      this.taskRequest.userId = this.userId;
      const {data: res} = await this.$http.post(`/load/i/help/work/task/no/read/num`, this.taskRequest)
      this.iHelpNum = res.totalPage;

      this.taskRequest.receiveId = 0;
      this.taskRequest.creator = 0;
    },
    async loadSendMeTaskNum() {
      this.taskRequest.userId = this.userId;
      const {data: res} = await this.$http.post(`/load/send/me/work/task/no/read/num`, this.taskRequest)
      this.sendMeNum = res.totalPage;

      this.taskRequest.receiveId = 0;
      this.taskRequest.creator = 0;
    },
    ticketHandleSizeChange(val) {
      this.ticketPageSize = val;
      if (this.dataType == 1){
        this.loadTaskList();
      }
      if (this.dataType == 2){
        this.loadReadTaskList();
      }
      if (this.dataType == 2){
        this.loadReadTaskList();
      }
    },
    ticketHandleCurrentChange(val) {
      this.ticketCurrentPage = val;
      this.loadTaskList();
    },
    async jxHelpMethod(){
      this.jxWorkTask.jxHelpActors = this.showExistHelpActors;
      const {data:res} = await this.$http.post(`/jx/help`, this.jxWorkTask)
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadWaitTaskNum();
    // this.loadNotReadTaskNum();
    this.loadICreateTaskNum();
    this.loadIExeTaskNum();
    this.loadIHelpTaskNum();
    this.loadSendMeTaskNum();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 100vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 100vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  width: 30%;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  flex: 1;
  width: 70%;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/WorkTask.vue